import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { LoadingGkService } from '@services/ui/loading.service';

@Component({
	selector: 'app-loading-gk',
	imports: [CommonModule],
	templateUrl: './loading.component.html',
	styleUrls: ['./loading.component.scss'],
})
export class LoadingGkComponent {
	show = input<boolean>(false);

	constructor(public loadingGkService: LoadingGkService) {}
}
